module.exports = __webpack_public_path__ + "ca38424372f8384996206aaec7daa12a.png";